import { ReactNode } from 'react';

import classNames from 'classnames';

import { comboboxStyles } from '../combobox.styles';
import { useComboboxContext } from '../ComboboxContext';

export interface ComboboxGroupLabelProps {
  className?: string;
  children?: ReactNode;
}

export const ComboboxGroupLabel = ({ className, children }: ComboboxGroupLabelProps) => {
  const { classNames: contextClassNames } = useComboboxContext();
  const styles = comboboxStyles();

  return (
    <div className={classNames(styles.groupLabel(), contextClassNames?.groupLabel, className)}>
      {children}
    </div>
  );
};
